module.exports = __webpack_public_path__ + "static/media/cart-shopping-solid.16aad48a.png";